import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { formSubmissionRefs } from "../subjects/formSubmission/refs";

/**
 * The driver reported a load refused at the customer.
 */
export const loadRefusedV1 = tmsEventKind(
  { category: "exception", kind: "loadRefused", version: 1 },
  {
    refs: formSubmissionRefs,
    facts: {
      orderNumber: z.string().nullable(),
      /** A vendor dropdown, but its options are per tenant and unenumerated; a string until one is pinned. */
      refusalReason: z.string().nullable(),
    },
  },
);

export const LoadRefusedV1Schema = loadRefusedV1.schema;
export const LoadRefusedV1FactsSchema = loadRefusedV1.facts;

export type LoadRefusedV1 = z.infer<typeof LoadRefusedV1Schema>;
export type LoadRefusedV1Facts = z.infer<typeof LoadRefusedV1FactsSchema>;

/** Every version of `loadRefused`, keyed by version. What `catalog.ts` places under `exception`. */
export const loadRefused = { 1: loadRefusedV1 } as const;
